import React from 'react';
import { makeStyles, TablePagination as NativeTablePagination } from '@material-ui/core';
import { usePagination } from 'hooks/pagination';

const useStyles = makeStyles({
  selectRoot: {
    marginRight: 10,
  },
  toolbar: {
    paddingLeft: '0!important',
  },
  actions: {
    marginLeft: 0,
  },
});

type ApiPaginationProps = {
  count: number;
  onChangePage(page: number): void;
  onChangeRowsPerPage(rows: number): void;
};

const ApiPagination: React.FC<ApiPaginationProps> = ({ count, onChangePage, onChangeRowsPerPage }) => {
  const { rowsPerPage, page, rowsPerPageOption, handleSetPage, handleSetRowsPerPage } = usePagination();
  const classes = useStyles();

  function handlePageChange(page: number) {
    onChangePage(page);
    handleSetPage(page);
  }

  function handleRowsPerPageChange(rows: number) {
    handlePageChange(0);
    handleSetRowsPerPage(rows);
    onChangeRowsPerPage(rows);
  }

  return (
    <NativeTablePagination
      classes={{ selectRoot: classes.selectRoot, toolbar: classes.toolbar, actions: classes.actions }}
      labelRowsPerPage="Registros"
      rowsPerPageOptions={rowsPerPageOption}
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      backIconButtonProps={{
        'aria-label': 'Página anterior',
      }}
      nextIconButtonProps={{
        'aria-label': 'Próxima Página',
      }}
      onPageChange={(e, page) => handlePageChange(page)}
      onRowsPerPageChange={e => handleRowsPerPageChange(parseFloat(e.target.value))}
    />
  );
};

export default ApiPagination;
